import ui from './ui.json'

export default {
  language: 'Español',
  ...ui
}
